import React from "react";
import { Redirect } from "react-router-dom";

/**
 * Legacy URL: KYC is shown in-app via KycPendingOverlay after login.
 */
export default function KycRedirect() {
  return <Redirect to="/converters/identify" />;
}
